<header class="topbar">
    <nav class="navbar top-navbar navbar-expand-md navbar-light" style="background-color: #f9f3e1;">

        <div class="navbar-header" style="background-color: #f9f3e1;">
            <a class="navbar-brand" routerLink="/dashboard">
                <b>
                    <img src="./assets/images/logo casa.png" width="35px" height="35px" alt="homepage" class="dark-logo" />
                    <img src="./assets/images/logo casa.png" width="35px" height="35px" alt="homepage" class="light-logo" />
                </b>
            </a>
        </div>

        <div class="navbar-collapse">

            <ul class="navbar-nav mr-auto">
                <li class="nav-item">
                    <a class="nav-link nav-toggler hidden-md-up waves-effect waves-dark" href="javascript:void(0)">
                        <i style="color: #7a0836;" class="ti-menu"></i>
                    </a>
                </li>

                <li class="nav-item">
                    <a class="nav-link sidebartoggler hidden-sm-down waves-effect waves-dark" href="javascript:void(0)">
                        <i style="color: #7a0836;" class="ti-menu"></i>
                    </a>
                </li>
            </ul>

            <div class="navbar-collapse" style="text-align: center; background: transparent;">
                <img class="rounded mx-auto d-block" src="./assets/images/PLECA SIGA.png" width="580px" height="90px" style="background: transparent;">
            </div>

            <!-- PERFIL -->
            <ul class="navbar-nav my-lg-0">
                <li class="nav-item dropdown">

                    <a class="nav-link dropdown-toggle waves-effect waves-dark" href="" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">

                        <span style="
                            width: 42px;
                            height: 42px;
                            background: #f3e9d0;
                            border-radius: 50%;
                            display: flex;
                            align-items: center;
                            justify-content: center;
                            border: 2px solid #f3e9d0;
                        ">
                            <i class="fa-solid fa-user" style="font-size: 20px; color: #7a0836;"></i>
                        </span>

                    </a>

                    <div class="dropdown-menu dropdown-menu-right animated fadeIn fast" style="background: #640b32; border-radius: 6px;">

                        <ul class="dropdown-user" style="padding: 10px;">

                            <li>
                                <div class="dw-user-box">
                                    <div class="u-text">
                                        <li style="color: #f3e9d0; font-size: 16px; text-align:center;">
                                            <b>{{ Nombre }}</b>
                                        </li>
                                        <br>
                                    </div>
                                </div>
                            </li>

                            <li role="separator" class="divider" style="border-top: 1px solid rgba(255,255,255,0.1); margin: 8px 0;"></li>

                            <li>
                                <a style="color: #f3e9d0; padding: 10px 5px; display:flex; align-items:center;">
                                    <i class="fa-solid fa-school" style="margin-right: 8px; color: #f3e9d0;"></i>
                                    <b>{{ plantel }}</b>
                                </a>
                            </li>

                            <li>
                                <a style="color: #f3e9d0; padding: 10px 5px; display:flex; align-items:center;">
                                    <i class="fa-solid fa-envelope" style="margin-right: 8px; color: #f3e9d0;"></i>
                                    <b>{{ Correo }}</b>
                                </a>
                            </li>

                            <li role="separator" class="divider" style="border-top: 1px solid rgba(255,255,255,0.1); margin: 8px 0;"></li>

                            <li>
                                <a routerLink="/login" style="
                                       color: #f3e9d0;
                                       padding: 10px 5px;
                                       display: flex;
                                       align-items:center;
                                       transition: 0.2s;
                                   ">
                                    <i class="fa-solid fa-right-from-bracket" style="margin-right: 8px; color:#f3e9d0;"></i>
                                    <b>Cerrar sesión</b>
                                </a>
                            </li>

                        </ul>
                    </div>

                </li>
            </ul>

            <h5 style="text-align: left; color: #640b32; margin-left: 10px;">
                {{ Nombre }}
            </h5>

        </div>
    </nav>
</header>

<style>
    .dropdown-user a:hover {
        background: rgba(255, 255, 255, 0.08) !important;
        color: #f3e9d0 !important;
        border-radius: 4px;
    }
</style>